import { flattenErrorStrings } from "utils/b2cRedirectErrors";

/**
 * Returns true when the browser reports no network connectivity.
 * @returns {boolean}
 */
export function isBrowserOffline() {
  return typeof navigator !== "undefined" && navigator.onLine === false;
}

/**
 * Returns true for transient fetch / transport failures (e.g. Wi‑Fi still reconnecting
 * after sleep). These are not auth errors but during wake-up we treat them as session
 * invalidation so the user is sent through interactive login instead of crashing.
 *
 * @param {unknown} error
 * @returns {boolean}
 */
export function isNetworkFetchError(error) {
  if (isBrowserOffline()) {
    return true;
  }

  if (error instanceof TypeError) {
    const message = (error.message || "").toLowerCase();
    if (
      message.includes("failed to fetch") ||
      message.includes("networkerror") ||
      message.includes("network request failed") ||
      message.includes("load failed")
    ) {
      return true;
    }
  }

  const errorCode =
    typeof error === "object" && error !== null && "code" in error
      ? String(error.code)
      : "";
  if (
    errorCode === "ERR_NETWORK" ||
    errorCode === "ECONNABORTED" ||
    errorCode === "ETIMEDOUT"
  ) {
    return true;
  }

  const normalized = flattenErrorStrings(error).join(" ").toLowerCase();
  return (
    normalized.includes("failed to fetch") ||
    normalized.includes("network error") ||
    normalized.includes("networkerror") ||
    normalized.includes("err_network") ||
    normalized.includes("net::err") ||
    normalized.includes("network request failed") ||
    normalized.includes("load failed")
  );
}
